import { LocalizeProvider } from "react-localize-redux";
import { renderToStaticMarkup } from "react-dom/server";
import globalTranslations from "./translations/global.json";
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import createTheme from "./theme";
import { CustomThemeProvider } from "./themeProvider";
import { Helmet } from "react-helmet";
import { ThemeProvider } from "styled-components";
import { create } from "jss";
import StylesProvider from '@mui/styles/StylesProvider';
import jssPreset from '@mui/styles/jssPreset';
import {
    QueryClient,
    QueryClientProvider,
  } from 'react-query'
import store from "./redux/store/index";
import axios from 'axios';
import axiosClient from './utils/axios';
import DatePickerProvider from "./components/DatePickerProvider";
import { installSessionExpiryInterceptors } from "./services/sessionExpiryInterceptors";
import { installWebSessionScopeInterceptors } from "./services/webSessionScope";

const jss = create({
    ...jssPreset(),
    insertionPoint: document.getElementById("jss-insertion-point"),
});

installSessionExpiryInterceptors([axios, axiosClient]);
// SKIN-600: a dermatologist web session's 403 WEB_SESSION_OUT_OF_SCOPE is told, never a logout.
installWebSessionScopeInterceptors([axios, axiosClient]);

// Create a client
const queryClient = new QueryClient()


function OtherProviders(props){
    
    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <StylesProvider jss={jss}>
                    <CustomThemeProvider>
                        <LocalizeProvider initialize={{
                            languages: [
                            { name: "English", code: "en" },
                            { name: "Spanish", code: "es" },
                            { name: "Français", code: "fr" }
                            ],
                            translation: globalTranslations,
                            options: {
                            defaultLanguage: localStorage.getItem("language") ? localStorage.getItem("language") :  "en",
                                renderToStaticMarkup: renderToStaticMarkup
                            }
                        }}>
                            <DatePickerProvider>
                                { props.children }
                            </DatePickerProvider>
                        </LocalizeProvider>
                    </CustomThemeProvider>
                </StylesProvider>
            </BrowserRouter>
        </QueryClientProvider>
    );
}


export default function ProviderSherwood(props){
    const title = import.meta.env.VITE_APP_PRODUCT === "HOSPITAL" ? "Hospital platform" : "Researcher platform"
    if (props.initStore) {
        props.initStore.map((initObject) => {
            store.dispatch({ type: initObject.type, payload: initObject.payload })
        })
    }
    return (
        <Provider store={store}>
            <Helmet
                titleTemplate="%s | Sherwood"
                defaultTitle={title}
            />
            <OtherProviders>
                { props.children }
            </OtherProviders>
        </Provider>
    )
    
}
